export enum MeritProcessType {
  Merit = 'Merit',
  Incentive = 'Incentive'
}
